(() => {
  if (window.SNEditorial) { window.SNEditorial.init(document); return; }
  const init = (scope = document) => {
    const roots = [...scope.querySelectorAll("[data-sn-editorial]")];
    if (scope.matches?.('[data-sn-editorial]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (root.dataset.snEditorialReady) return;
      root.dataset.snEditorialReady = "true";

      const cards = [...root.querySelectorAll(".sn-pdp-editorial-card")];
      cards.forEach((card) => {
        card.addEventListener("toggle", () => {
          if (!card.open) return;
          cards.forEach((other) => {
            if (other !== card) other.open = false;
          });
        });
      });
    });
  };

  window.SNEditorial = { init };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
